export default "__VITE_ASSET__sR_0xraR__"